import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { AppProvider, Page, Card, DisplayText } from '@shopify/polaris';

import translations from '@shopify/polaris/locales/es.json';
import TransactionsHistory from './components/SaleReportTransactionsHistory';
import AutocompleteSearch from "@presentational/AutocompleteSearch";

import ResourceTableHeaders from '@presentational/ResourceTableHeaders';
import ResourceTableBody from '@presentational/ResourceTableBody';

import * as shapes from 'utils/shapeProps';
import join from 'lodash/join';

const propTypes = {
  transactionsReport: shapes.transactionsReportShape, // per seller
  saleReport: PropTypes.object.isRequired,
  pdfURL: PropTypes.string.isRequired,
  csvURL: PropTypes.string.isRequired,
  excelURL: PropTypes.string.isRequired,

  isSeller: PropTypes.bool.isRequired,
  sellerUsers: shapes.selectOptionsShape,
};

const sellerTotalColumns = [
  {  size: 4, header: I18n.t("activerecord.attributes.transfer.vendor"), accessor: "vendor" },
  {  size: 2, header: I18n.t("activerecord.attributes.general.currency"), accessor: "currency_code" },
  {  size: 4, header: I18n.t("activerecord.attributes.general.total"), accessor: "transaction_totals_money" },
]

const SaleReportShow = (props) => {
  console.log("Props", props);
  const { saleReport } = props;
  const [selected, setSelected] = useState(0);
  const [focusedSellerData, setFocusedSellerData] = useState( props.isSeller ? props.transactionsReport.report_items[0] : null )

  const handleUserChange = (userId) => {
    const sellerReportData = props.transactionsReport.report_items.find( (reportItem) => reportItem.user_id == userId );
    console.log("Seller Report Data", sellerReportData)
    setFocusedSellerData(sellerReportData);
  };

  const handleClearUser = useCallback(() => setFocusedSellerData(null));

  let actions = [
    { content: 'Exportar PDF', url: props.pdfURL, external: true },
    { content: 'Exportar CSV', url: props.csvURL, external: true },
    { content: 'Exportar XLSX', url: props.excelURL, external: true },
  ];

  // array of strings. If filtering only display filtered seller totals on Resumen (which have one number not an array)
  const focusedSellerTotalMoney = (focusedSellerData && focusedSellerData.transaction_totals_money);

  console.log("FSD", focusedSellerData);

  return(
    <AppProvider i18n={translations}>
      <Page
        fullWidth
        title={`${I18n.t("activerecord.models.sale_report.one")} ${saleReport.display_id}`}
        titleMetadata={ saleReport.date_range }
        breadcrumbs={[{content: I18n.t("actions.back"), url: '/sale_reports'}]}
        actionGroups={[
          {
            title: 'Exportar',
            accessibilityLabel: 'Action group label',
            actions: actions,
          },
        ]}
      >
        <div className='boxshadow'>
          <Card>
            <Card.Header title="Ventas">
              { !!props.sellerUsers &&
                <AutocompleteSearch
                  placeholder = "Seleccionar Seller..."
                  filterOptions = { props.sellerUsers }
                  onClearCallback={ handleClearUser }
                  searchDelay={ 100 }
                  onSelectionCallback={ (selectedOptions) => handleUserChange(selectedOptions[0]) }
                />
              }
            </Card.Header>
            
            {/* Default view for Admin. Display saleReport.totals_money */}
            <Card.Section>
              <div>
                <DisplayText size="medium"><strong>{ focusedSellerTotalMoney || join(saleReport.totals_money, " y ") || 0 }</strong></DisplayText>
              </div>
            </Card.Section>

            {/* When not focusing specific Seller as admin, display the resume of all */}
            { !props.isSeller && !focusedSellerData &&
                <div>
                  <ResourceTableHeaders columnsInfo={ sellerTotalColumns } />
                  <ResourceTableBody
                    columnsInfo={ sellerTotalColumns }
                    items={ props.transactionsReport.report_items }
                  />
                </div>
              }

            { focusedSellerData &&
              <TransactionsHistory 
                isSeller={ props.isSeller } 
                transferURLBase={ props.transferURLBase } 
                transactions={ focusedSellerData.transaction_history } 
                transactionTotalsMoney={ focusedSellerData.transaction_totals_money }
                displayTransferColumn={ props.isSeller ? false : true }
              />
            }
          </Card>
        </div>

        
      </Page>
    </AppProvider>
  )
}

const SubstractionReasons = ({ reasons }) => (
  <div>
    { reasons.map( (reason, index) => (
      <p key={ index }>{ reason }</p>  
    ))}
  </div>
)


SaleReportShow.propTypes = propTypes;


export default SaleReportShow;
